import { Component, OnInit, inject, signal } from "@angular/core";
import { UntypedFormBuilder, Validators, UntypedFormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "../auth.service";
import { NgxSpinnerService } from "ngx-spinner";

import { Bind } from "primeng/bind";
import { InputText } from "primeng/inputtext";
import { ButtonDirective } from "primeng/button";
import { TPipe } from "../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.css"],
    imports: [TPipe, FormsModule, ReactiveFormsModule, Bind, InputText, ButtonDirective]
})
export class LoginComponent implements OnInit {
  private fb = inject(UntypedFormBuilder);
  private router = inject(Router);
  private authService = inject(AuthService);
  private spinner = inject(NgxSpinnerService);

  loginForm: UntypedFormGroup;
  readonly submitted = signal(false);
  returnUrl: string;
  readonly error = signal<{}>(undefined);
  readonly loginError = signal<string>(undefined);
  readonly decodedUser = signal<any>(undefined);

  ngOnInit() {
    this.loginForm = this.fb.group({
      username: ["", Validators.required],
      password: ["", Validators.required],
    });
  }

  get username() {
    return this.loginForm.get("username");
  }
  get password() {
    return this.loginForm.get("password");
  }

  onSubmit() {
    this.submitted.set(true);

    if (this.loginForm.invalid) return;

    this.authService
      .login(this.username?.value, this.password?.value)
      .subscribe(
        (data) => {
          if (this.authService.isLoggedIn()) {
            this.decodedUser.set(this.authService.getDecodedToken());
            console.log("Decoded JWT payload:", this.decodedUser());

            const redirect = this.authService.redirectUrl || "/admin";
            this.router.navigateByUrl(redirect).then((success) => {
              if (!success) {
                this.loginError.set("Failed to navigate after login.");
              }
            });
          } else {
            this.loginError.set("Username or password is incorrect.");
          }
        },
        (error) => {
          this.error.set(error);
          this.loginForm.reset();

          if (error.error?.message) {
            this.loginError.set(error.error.message);
          } else if (error.status === 0) {
            this.loginError.set("Cannot connect to server. Please try again later.");
          } else {
            this.loginError.set("An unexpected error occurred.");
          }
        }
      );
  }
}
